/**
 * Instalador do atalho "DentalBook Etiquetas" para o PC da impressora: um .cmd que acha o Chrome (ou
 * o Edge, que todo Windows tem) e cria o atalho na área de trabalho e na inicialização do Windows.
 *
 * O atalho abre um perfil do navegador só dele (`--user-data-dir`), em janela de aplicativo, com
 * `--kiosk-printing`: tudo o que essa janela imprime vai direto pra impressora padrão, sem diálogo.
 * O navegador do dia a dia não muda.
 *
 * Texto em ASCII de propósito: o prompt do Windows não mostra acento direito.
 */
export function instaladorDoAtalho(urlDoApp: string, pastas: string[] = ["Desktop", "Startup"]) {
  const url = `${urlDoApp}/lab/pedidos?estacao=etiquetas`;
  const navegadores = [
    "%ProgramFiles%\\Google\\Chrome\\Application\\chrome.exe",
    "%ProgramFiles(x86)%\\Google\\Chrome\\Application\\chrome.exe",
    "%LOCALAPPDATA%\\Google\\Chrome\\Application\\chrome.exe",
    "%ProgramFiles(x86)%\\Microsoft\\Edge\\Application\\msedge.exe",
    "%ProgramFiles%\\Microsoft\\Edge\\Application\\msedge.exe",
  ];
  const destinos = pastas.map((p) => (p === "Desktop" || p === "Startup" ? `[Environment]::GetFolderPath('${p}')` : `'${p}'`)).join(",");
  const powershell = [
    "$w = New-Object -ComObject WScript.Shell",
    "$opcoes = '--kiosk-printing --user-data-dir=\\\"' + $env:DB_PERFIL + '\\\" --app=' + $env:DB_URL",
    // Ícone do DentalBook baixado do próprio site; se falhar, o atalho fica com o do navegador.
    "$ico = Join-Path (Join-Path $env:LOCALAPPDATA 'DentalBook') 'dentalbook.ico'",
    "$icone = $env:DB_NAV + ',0'",
    "try { [Net.ServicePointManager]::SecurityProtocol = 'Tls12'; New-Item -ItemType Directory -Force (Split-Path $ico) | Out-Null; Invoke-WebRequest -UseBasicParsing $env:DB_ICONE -OutFile $ico; $icone = $ico + ',0' } catch {}",
    `foreach ($pasta in @(${destinos})) { $a = $w.CreateShortcut((Join-Path $pasta 'DentalBook Etiquetas.lnk')); $a.TargetPath = $env:DB_NAV; $a.Arguments = $opcoes; $a.WorkingDirectory = (Split-Path $env:DB_NAV); $a.IconLocation = $icone; $a.Save() }`,
  ].join("; ");
  return [
    "@echo off",
    "title DentalBook - atalho de etiquetas",
    `set "DB_URL=${url}"`,
    `set "DB_ICONE=${urlDoApp}/dentalbook.ico"`,
    'set "DB_PERFIL=%LOCALAPPDATA%\\DentalBook\\EstacaoDeEtiquetas"',
    'set "DB_NAV="',
    ...navegadores.map((n) => `if not defined DB_NAV if exist "${n}" set "DB_NAV=${n}"`),
    "if not defined DB_NAV (",
    "  echo Nao encontramos o Google Chrome nem o Microsoft Edge neste computador.",
    "  pause",
    "  exit /b 1",
    ")",
    `powershell -NoProfile -Command "${powershell}"`,
    "if errorlevel 1 (",
    "  echo Nao foi possivel criar o atalho.",
    "  pause",
    "  exit /b 1",
    ")",
    "echo.",
    "echo Pronto! O atalho \"DentalBook Etiquetas\" foi criado na area de trabalho",
    "echo e vai abrir sozinho quando o computador ligar.",
    "echo.",
    "echo Abra pelo atalho, entre com sua conta e aceite os pedidos por essa janela.",
    "pause",
  ].join("\r\n");
}

/**
 * Plano B sem baixar nada (antivírus que barra o .cmd): o texto que a pessoa cola em Novo › Atalho.
 * Perfil numa pasta fixa: no atalho feito à mão não dá pra contar com %LOCALAPPDATA% expandido.
 */
export function destinoDoAtalhoManual(navegador: "chrome" | "edge", urlDoApp: string) {
  const exe =
    navegador === "chrome"
      ? "C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe"
      : "C:\\Program Files (x86)\\Microsoft\\Edge\\Application\\msedge.exe";
  return `"${exe}" --kiosk-printing --user-data-dir="C:\\DentalBook\\EstacaoDeEtiquetas" --app=${urlDoApp}/lab/pedidos?estacao=etiquetas`;
}

/** Baixa o instalador pelo navegador. */
export function baixarInstaladorDoAtalho() {
  const blob = new Blob([instaladorDoAtalho(window.location.origin)], { type: "application/octet-stream" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "Instalar atalho DentalBook Etiquetas.cmd";
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}
